import React, { useEffect, useState } from "react";
import Modal from "react-modal"
import { adminServices } from "../../services/AdminServices";
import InputText1 from '../InputText1';
import InputText2 from '../InputText2';
import Button from '../Button';
import LoadingModal from "../LoadingModal";
import AlertModal from "../AlertModal";
const customStyles = { 
    overlay: { 
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
    }, 
    content: {
        width: '80%', margin: 'auto', 
        height : '350px'
      
    },
 };

const EmailRecipientsComponent = ({show,onClose})=>{
    const [setting, setSetting] = useState('');
    const [cashOut, setCashOut] = useState('');
    const [adminApprover, setAdminApprover] = useState('');
    const [releasing, setReleasing] = useState('');
    const [supervisor, setSupervisor] = useState('');
    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('Please fill all fields');
    const [error, setError] = useState(false);

    useEffect(()=>{
        getRecipients();
    },[]);

    const getRecipients = async () => {
        setLoading(true);
        await adminServices.recipients().then(response => {
            let data = response.data[0];
            setSetting(data.setting);
            setCashOut(data.cashOut); 
            setAdminApprover(data.admin);
            setReleasing(data.releasing);
            setSupervisor(data.supervisorEmail);
            setLoading(false);
        }).catch(error => {
            if(error.status == 401){
                window.location.href = "/";
            }
        });
    }

    const handleSave = async () => {
        setLoading(true);
        setErrorMessage('Please fill all fields');
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; 

        if(!emailPattern.test(setting) && !emailPattern.test(cashOut) && !emailPattern.test(adminApprover) && !emailPattern.test(releasing)){
            setLoading(false);
            setError(true);
            setErrorMessage('Please enter valid email address');
            return;
        }

        if(!emailPattern.test(setting)){
            setLoading(false);
            setError(true);
            setErrorMessage('Please enter a valid email on Settings Approver field');
            return;
        }

        if(!emailPattern.test(cashOut)){
            setLoading(false);
            setError(true);
            setErrorMessage('Please enter a valid email on Cash Out Approver field');
            return;
        }

        if(!emailPattern.test(adminApprover)){
            setLoading(false);
            setError(true);
            setErrorMessage('Please enter a valid email on Admin Approver field');
            return;
        }

        if(!emailPattern.test(releasing)){
            setLoading(false);
            setError(true);
            setErrorMessage('Please enter a valid email on Releasing field');
            return;
        }

         if(!emailPattern.test(supervisor)){
            setLoading(false);
            setError(true);
            setErrorMessage('Please enter a valid email on Releasing field');
            return;
        }

        const data = {
            recordId: 1,
            setting: setting,
            cashOut: cashOut,
            admin: adminApprover,
            releasing: releasing,
            supervisorEmail: supervisor
        }
        await adminServices.updateRecipients(data).then(response => {
            setLoading(false);
            onClose();
        }).catch(error => {
            if(error.status == 401){
                window.location.href = "/";
            }
            //console.log(error);
        });
    }

    return (
        
        <Modal
            
            isOpen={show}
            shouldCloseOnEsc={false} 
            shouldCloseOnOverlayClick={false}
            style={customStyles}
            onRequestClose={onClose}
        >
            <LoadingModal show={loading} message={"Loading..."} />
            <AlertModal show={error} message={errorMessage} onClose={()=>setError(false)} />
         <div style={{display:"flex",justifyContent:'space-between',zIndex:999}}>
                <h3>Automated Email Recipients</h3>
                <button style={{backgroundColor:'#fff',
                    borderColor:'#d2d2d2',
                    color:'#555',
                    borderRadius:100,
                    fontSize:20,
                    fontWeight: 'bolder',
                    fontFamily: 'monospace',
                    borderWidth:0}}
                    onClick={onClose}
                    >
                        x
                    </button>
            </div>

            <div className="d-flex w-100 flex-row justify-content-start">
                <div className="w-25">
                    <InputText1 title={"Settings Approver"} value={setting} onChange={(e)=>{ setSetting(e.target.value) }} />
                </div>
                <div className="w-25">
                    <InputText1 title={"Cash Out Approver"} value={cashOut} onChange={(e)=>{ setCashOut(e.target.value) }} />
                </div>
                <div className="w-25">
                    <InputText1 title={"Admin Approver"} value={adminApprover} onChange={(e)=>{ setAdminApprover(e.target.value) }} />
                </div>
                
            </div>

            <div className="d-flex w-100 flex-row justify-content-start">
                <div className="w-25">
                    <InputText1 title={"Releasing"} value={releasing} onChange={(e)=>{ setReleasing(e.target.value) }} />
                </div>

                <div className="w-25">
                    <InputText1 title={"Supervisor"} value={supervisor} onChange={(e)=>{ setSupervisor(e.target.value) }} />
                </div>
                
            </div>

            <div className="flexRow" style={{justifySelf:'end'}}>
                    <div>
                        {validated ? <p style={{color:'red',marginTop:10}}>{error && errorMessage}&nbsp;</p> : ""}
                    </div>
                    <Button variant={"success"} size={'md'} onClick={handleSave}>
                        Save
                    </Button>
                    &nbsp;
                    <Button variant={"secondary"} size={'md'} onClick={onClose}>
                        Cancel
                    </Button>
            </div>
        </Modal>
    )
}

export default EmailRecipientsComponent;